export default __webpack_public_path__ + "static/media/insta.93658a6b.svg";